import React, {
  useState,
  useEffect,
  useRef,
  useContext,
  useCallback,
} from "react";

import { useHistory, useParams } from "react-router-dom";
import { parseISO } from "date-fns";
import clsx from "clsx";
import {
  getStoredCompanyTimezone,
  formatCompanyTime,
  formatCompanyDate,
  resolveCompanyTimezone
} from "../../utils/companyTimezone";
import moment from "moment-timezone";

import { makeStyles, useTheme } from "@material-ui/core/styles";
import { green, grey } from "@material-ui/core/colors";
import { i18n } from "../../translate/i18n";

import api from "../../services/api";
import MarkdownWrapper from "../MarkdownWrapper";
import { AuthContext } from "../../context/Auth/AuthContext";
import { TicketsContext } from "../../context/Tickets/TicketsContext";
import toastError from "../../errors/toastError";
import { v4 as uuidv4 } from "uuid";

import GroupIcon from "@material-ui/icons/Group";
import ContactTag from "../ContactTag";
import ConnectionIcon from "../ConnectionIcon";
import AcceptTicketWithouSelectQueue from "../AcceptTicketWithoutQueueModal";
import TransferTicketModalCustom from "../TransferTicketModalCustom";
import ShowTicketOpen from "../ShowTicketOpenModal";
import FinalizacaoVendaModal from "../FinalizacaoVendaModal";
import ConfirmationModal from "../ConfirmationModal";
import ShowTicketLogModal from "../ShowTicketLogModal";
import TicketMessagesDialog from "../TicketMessagesDialog";
import { isNil } from "lodash";
import { toast } from "react-toastify";
import { Done, CheckCircleOutline, SwapHoriz, Add, PersonAdd, Undo, DeleteOutline, DeviceHubOutlined, History, PictureAsPdf } from "@material-ui/icons";
import VisibilityIcon from "@material-ui/icons/Visibility"; // Ícone de spy
import useCompanySettings from "../../hooks/useSettings/companySettings";
import NewTicketModal from "../NewTicketModal";
import { getTicketDisplayNumber } from "../../utils/ticketNumber";
import {
  Avatar,
  Badge,
  ListItemAvatar,
  ListItem,
  ListItemText,
  Typography,
  MenuItem,
  ListItemIcon,
  Dialog,
  DialogTitle,
  DialogActions,
  Button,
  DialogContent,
  Divider,
  Paper,
} from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  ticket: {
    position: "relative",
    margin: "1px 0",
    width: "100%",
    boxSizing: "border-box",
    paddingLeft: 6,
    paddingRight: 6,
    borderRadius: 14,
    paddingTop: 2,
    paddingBottom: 2,
    backgroundColor: theme.mode === "light" ? "#ffffff" : "#1f1f1f",
    border: `1px solid ${theme.mode === "light" ? "rgba(15, 23, 42, 0.08)" : "rgba(255, 255, 255, 0.08)"}`,
    transition: "background-color 120ms ease, box-shadow 120ms ease, border-color 120ms ease",
    "&:hover": {
      backgroundColor: theme.mode === "light" ? "#f3f4f6" : "#2a2a2a",
      boxShadow: "0 4px 14px rgba(15, 23, 42, 0.12)",
    },
    "&.Mui-selected": {
      backgroundColor: theme.mode === "light" ? "#e8f0fe" : "#283241",
      borderColor: theme.mode === "light" ? "rgba(37, 99, 235, 0.38)" : "rgba(96, 165, 250, 0.48)",
      boxShadow: "0 6px 18px rgba(37, 99, 235, 0.18)",
    },
    "&.Mui-selected:hover": {
      backgroundColor: theme.mode === "light" ? "#deebff" : "#334155",
    },
  },

  pendingTicket: {
    cursor: "unset",
  },
  queueTag: {
    background: "#FCFCFC",
    color: "#000",
    marginRight: 1,
    padding: 1,
    fontWeight: "bold",
    borderRadius: 3,
    fontSize: 6,
    whiteSpace: "nowrap",
  },
  noTicketsDiv: {
    display: "flex",
    height: "100px",
    margin: 40,
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },
  newMessagesCount: {
    alignSelf: "flex-end",
    minWidth: 18,
    height: 18,
    padding: "0 5px",
    borderRadius: 999,
    backgroundColor: green[500],
    color: "#fff",
    fontSize: 10,
    lineHeight: "18px",
    fontWeight: "bold",
    textAlign: "center",
    boxSizing: "border-box",
  },
  noTicketsText: {
    textAlign: "center",
    color: "rgb(104, 121, 146)",
    fontSize: "14px",
    lineHeight: "1.4",
  },
  connectionTag: {
    background: "green",
    color: "#FFF",
    marginRight: 1,
    padding: 1,
    fontWeight: "bold",
    borderRadius: 3,
    fontSize: 6,
  },
  noTicketsTitle: {
    textAlign: "center",
    fontSize: "16px",
    fontWeight: "600",
    margin: "0px",
  },

  contactNameWrapper: {
    display: "flex",
    justifyContent: "space-between",
    marginLeft: "5px",
    fontWeight: "bold",
    color: theme.mode === "light" ? "black" : "white",
  },
  primaryContentRow: {
    display: "flex",
    alignItems: "flex-start",
    width: "100%",
    minWidth: 0,
  },
  primaryLeftContent: {
    minWidth: 0,
    flex: 1,
  },

  lastMessageTime: {
    textAlign: "right",
    whiteSpace: "nowrap",
    fontSize: 8,
    color: theme.mode === "light" ? "black" : grey[400],
  },

  lastMessageTimeUnread: {
    textAlign: "right",
    whiteSpace: "nowrap",
    fontSize: 8,
    color: "green",
    fontWeight: "bold",
  },

  closedBadge: {
    alignSelf: "center",
    justifySelf: "flex-end",
    marginRight: 32,
    marginLeft: "auto",
  },

  contactLastMessage: {
    paddingRight: "0%",
    marginLeft: "5px",
    fontSize: 10,
    lineHeight: "12px",
    color: theme.mode === "light" ? "black" : grey[400],
  },

  contactLastMessageUnread: {
    paddingRight: 20,
    fontWeight: "bold",
    fontSize: 10,
    lineHeight: "12px",
    color: theme.mode === "light" ? "black" : grey[400],
    // width: "50%",
  },

  badgeStyle: {
    color: "white",
    backgroundColor: green[500],
  },

  acceptButton: {
    position: "absolute",
    right: "1px",
  },

  ticketQueueColor: {
    flex: "none",
    width: 4,
    borderTopLeftRadius: 14,
    borderBottomLeftRadius: 14,
    height: "100%",
    position: "absolute",
    top: "0%",
    left: "0%",
  },

  ticketInfo: {
    position: "relative",
    top: -13,
  },
  secondaryContentSecond: {
    display: "flex",
    alignItems: "flex-start",
    flexWrap: "nowrap",
    flexDirection: "row",
    alignContent: "flex-start",
  },
  secondaryContentRow: {
    display: "flex",
    alignItems: "center",
    width: "100%",
    minWidth: 0,
  },
  secondaryLeftContent: {
    minWidth: 0,
    flex: 1,
  },
  ticketRightInfo: {
    marginLeft: "auto",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-end",
    justifyContent: "center",
    gap: 4,
    minWidth: "fit-content",
    paddingRight: 2,
  },
  ticketInfo1: {
    position: "relative",
    top: 13,
    right: 0,
  },
  Radiusdot: {
    "& .MuiBadge-badge": {
      borderRadius: 2,
      position: "inherit",
      height: 16,
      margin: 2,
      padding: 3,
    },
    "& .MuiBadge-anchorOriginTopRightRectangle": {
      transform: "scale(1) translate(0%, -40%)",
    },
  },
  connectionIcon: {
    marginRight: theme.spacing(1),
  },

  // Estilos para o modal da imagem
  imageModal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  imageModalContent: {
    outline: "none",
    maxWidth: "90vw",
    maxHeight: "90vh",
  },
  expandedImage: {
    width: "100%",
    height: "auto",
    maxWidth: "500px",
    borderRadius: theme.spacing(1),
  },
  clickableAvatar: {
    cursor: "pointer",
    "&:hover": {
      opacity: 0.8,
    },
  },
  contextMenuPaper: {
    borderRadius: 12,
    width: "fit-content",
    minWidth: 0,
    maxWidth: "calc(100vw - 24px)",
    padding: "4px 0",
    boxShadow:
      "0 12px 30px rgba(15, 23, 42, 0.14), 0 2px 8px rgba(15, 23, 42, 0.08)",
    border: "1px solid rgba(15, 23, 42, 0.06)",
    pointerEvents: "auto",
    overflow: "hidden",
  },
  contextMenuItem: {
    margin: "1px 4px",
    borderRadius: 8,
    minHeight: 32,
    gap: 6,
    paddingTop: 2,
    paddingBottom: 2,
    paddingLeft: 6,
    paddingRight: 8,
    fontSize: 14,
    whiteSpace: "nowrap",
    "& .MuiListItemText-root": {
      margin: 0,
      flex: "0 0 auto",
    },
    "& .MuiListItemText-primary": {
      fontSize: 14,
      lineHeight: "18px",
    },
    "&:hover": {
      backgroundColor: "rgba(59, 130, 246, 0.08)",
    },
  },
  contextMenuIcon: {
    minWidth: 22,
    marginRight: 4,
    color: theme.palette.text.secondary,
  },
  contextMenuTransfer: {
    color: "#2563eb",
    "& $contextMenuIcon": {
      color: "#2563eb",
    },
  },
  contextMenuDanger: {
    color: "#dc2626",
    "& $contextMenuIcon": {
      color: "#dc2626",
    },
    "&:hover": {
      backgroundColor: "rgba(220, 38, 38, 0.08)",
    },
  },
  contextMenuDivider: {
    margin: "4px 8px",
    opacity: 0.7,
  },
}));

const TicketListItemCustom = ({ setTabOpen, ticket }) => {
  const classes = useStyles();
  const theme = useTheme();
  const history = useHistory();
  const [, setLoading] = useState(false);
  const [
    acceptTicketWithouSelectQueueOpen,
    setAcceptTicketWithouSelectQueueOpen,
  ] = useState(false);
  const [transferTicketModalOpen, setTransferTicketModalOpen] = useState(false);
  const [transferMode, setTransferMode] = useState("transfer");
  const [newTicketModalOpen, setNewTicketModalOpen] = useState(false);

  const [openAlert, setOpenAlert] = useState(false);
  const [userTicketOpen, setUserTicketOpen] = useState("");
  const [queueTicketOpen, setQueueTicketOpen] = useState("");

  // Estados para o modal de finalização de venda
  const [openFinalizacaoVenda, setOpenFinalizacaoVenda] = useState(false);
  const [finalizacaoTipo, setFinalizacaoTipo] = useState(null);
  const [ticketDataToFinalize, setTicketDataToFinalize] = useState(null);
  const [showFinalizacaoOptions, setShowFinalizacaoOptions] = useState(false);
  const [confirmationOpen, setConfirmationOpen] = useState(false);
  const [showTicketLogOpen, setShowTicketLogOpen] = useState(false);
  const [openTicketMessageDialog, setOpenTicketMessageDialog] = useState(false);
  const [enableIntegration, setEnableIntegration] = useState(
    ticket.useIntegration
  );

  const [imageModalOpen, setImageModalOpen] = useState(false); // Estado para o modal da imagem
  const [selectedTicketForMenu, setSelectedTicketForMenu] = useState(null);
  const [contextMenuPosition, setContextMenuPosition] = useState(null);
  const [isContextMenuOpen, setIsContextMenuOpen] = useState(false);
  const [contextMenuInstanceKey, setContextMenuInstanceKey] = useState(0);
  const menuPaperRef = useRef(null);

  const { ticketId } = useParams();
  const isMounted = useRef(true);
  const { setCurrentTicket } = useContext(TicketsContext);
  const { user } = useContext(AuthContext);
  const companyTimezone = resolveCompanyTimezone(user?.company?.timezone || getStoredCompanyTimezone());

  console.log(`[TZ_CHAT_RENDER] Ticket list item render: ticketId=${ticket.id} | companyTimezone=${companyTimezone}`);

  const isAdmin = user?.profile === "admin";
  const canClosePendingTicket = isAdmin || user?.userClosePendingTicket === "enabled";
  const canUseConnectionActions = isAdmin || user?.allowConnections === "enabled";
  const canViewTicketHistory = isAdmin || user?.allHistoric === "enabled";
  const canDeleteTicket = isAdmin;

  const { get: getSetting } = useCompanySettings();

  useEffect(() => {
    return () => {
      isMounted.current = false;
    };
  }, []);

  // Função para abrir modal da imagem
  const handleImageClick = (e) => {
    e.stopPropagation(); // Prevenir que o clique no avatar selecione o ticket
    if (ticket?.contact?.profilePicUrl || ticket?.contact?.urlPicture) {
      setImageModalOpen(true);
    }
  };

  // Função para fechar modal da imagem
  const handleImageModalClose = () => {
    setImageModalOpen(false);
  };

  const closeContextMenu = useCallback(() => {
    setIsContextMenuOpen(false);
    setSelectedTicketForMenu(null);
    setContextMenuPosition(null);
  }, []);

  const handleContextMenu = (e, contextTicket) => {
    e.preventDefault();
    e.stopPropagation();

    const mouseX = e.clientX + 2;
    const mouseY = e.clientY - 6;
    const reopenMenu = () => {
      setSelectedTicketForMenu(contextTicket);
      setContextMenuPosition({
        mouseX,
        mouseY,
      });
      setContextMenuInstanceKey((prev) => prev + 1);
      setIsContextMenuOpen(true);
    };

    // Fecha qualquer menu já aberto neste card antes de reabrir reposicionado
    closeContextMenu();

    // Notifica outros cards para fechar seus menus contextuais
    window.dispatchEvent(
      new CustomEvent("ticket-context-menu-open", {
        detail: { ticketId: contextTicket?.id },
      })
    );

    // Forca reabertura real (evita batching que pode manter o menu "aberto")
    setTimeout(reopenMenu, 0);
  };

  useEffect(() => {
    if (!isContextMenuOpen) return;

    const blockNativeContextMenu = (event) => {
      event.preventDefault();
    };

    window.addEventListener("contextmenu", blockNativeContextMenu, true);

    return () => {
      window.removeEventListener("contextmenu", blockNativeContextMenu, true);
    };
  }, [isContextMenuOpen]);

  useEffect(() => {
    if (!isContextMenuOpen) return;

    const handlePointerDownOutside = (event) => {
      // Botao direito deve ser tratado pelo onContextMenu do card
      // para permitir "fechar e reabrir" sem cair no menu nativo.
      if (event.button === 2) {
        return;
      }

      if (menuPaperRef.current && menuPaperRef.current.contains(event.target)) {
        return;
      }
      closeContextMenu();
    };

    window.addEventListener("mousedown", handlePointerDownOutside, true);

    return () => {
      window.removeEventListener("mousedown", handlePointerDownOutside, true);
    };
  }, [isContextMenuOpen, closeContextMenu]);

  useEffect(() => {
    const handleOtherMenuOpen = (event) => {
      const openedTicketId = event?.detail?.ticketId;

      // Se outro card abriu menu, fecha este.
      if (openedTicketId && openedTicketId !== ticket.id) {
        closeContextMenu();
      }
    };

    window.addEventListener("ticket-context-menu-open", handleOtherMenuOpen);

    return () => {
      window.removeEventListener("ticket-context-menu-open", handleOtherMenuOpen);
    };
  }, [ticket.id, closeContextMenu]);

  const handleMenuAction = (action) => (e) => {
    e?.stopPropagation?.();
    closeContextMenu();
    action();
  };

  const handleOpenAcceptTicketWithouSelectQueue = useCallback(() => {
    setAcceptTicketWithouSelectQueueOpen(true);
  }, []);

  const handleCloseTicket = async (id) => {
    // Verificar se a finalização com valor de venda está ativa
    if (
      user.finalizacaoComValorVendaAtiva === true ||
      user.finalizacaoComValorVendaAtiva === "true"
    ) {
      // Se estiver ativa, abrir o modal de finalização de venda
      setFinalizacaoTipo("comDespedida");
      setOpenFinalizacaoVenda(true);
      handleSelectTicket(ticket);
      history.push(`/tickets/${ticket.uuid}`);
    } else {
      // Comportamento original
      const setting = await getSetting({
        column: "requiredTag",
      });

      if (setting.requiredTag === "enabled") {
        //verificar se tem uma tag
        try {
          const contactTags = await api.get(
            `/contactTags/${ticket.contact.id}`
          );
          if (!contactTags.data.tags) {
            toast.warning(i18n.t("messagesList.header.buttons.requiredTag"));
          } else {
            await api.put(`/tickets/${id}`, {
              status: "closed",
              userId: user?.id || null,
            });

            if (isMounted.current) {
              setLoading(false);
            }

            history.push(`/tickets/`);
          }
        } catch (err) {
          setLoading(false);
          toastError(err);
        }
      } else {
        setLoading(true);
        try {
          await api.put(`/tickets/${id}`, {
            status: "closed",
            userId: user?.id || null,
          });
        } catch (err) {
          setLoading(false);
          toastError(err);
        }
        if (isMounted.current) {
          setLoading(false);
        }

        history.push(`/tickets/`);
      }
    }
  };

  const handleCloseIgnoreTicket = async (id) => {
    setLoading(true);
    try {
      await api.put(`/tickets/${id}`, {
        status: "closed",
        userId: user?.id || null,
        sendFarewellMessage: false,
        amountUsedBotQueues: 0,
      });
    } catch (err) {
      setLoading(false);
      toastError(err);
    }
    if (isMounted.current) {
      setLoading(false);
    }

    history.push(`/tickets/`);
  };

  const handleReturnToQueue = async (id) => {
    setLoading(true);
    try {
      await api.put(`/tickets/${id}`, {
        status: "pending",
        userId: null,
      });
    } catch (err) {
      setLoading(false);
      toastError(err);
      return;
    }
    if (isMounted.current) {
      setLoading(false);
    }
    history.push(`/tickets/`);
  };

  const handleDeleteTicket = async () => {
    try {
      await api.delete(`/tickets/${ticket.id}`);
      history.push("/tickets");
    } catch (err) {
      toastError(err);
    }
  };

  const handleEnableIntegration = async () => {
    setLoading(true);
    try {
      await api.put(`/tickets/${ticket.id}`, {
        useIntegration: !enableIntegration,
      });
      setEnableIntegration(!enableIntegration);
    } catch (err) {
      toastError(err);
    } finally {
      setLoading(false);
    }
  };

  const handleShowLogTicket = () => {
    setShowTicketLogOpen(true);
  };

  const handleExportPDF = () => {
    setOpenTicketMessageDialog(true);
  };

  const truncate = (str, len) => {
    if (!isNil(str)) {
      if (str.length > len) {
        return str.substring(0, len) + "...";
      }
      return str;
    }
  };

  const handleCloseTransferTicketModal = useCallback(() => {
    if (isMounted.current) {
      setTransferTicketModalOpen(false);
      setTransferMode("transfer");
    }
  }, []);

  const handleOpenTransferModal = () => {
    setTransferMode("transfer");
    setLoading(true);
    setTransferTicketModalOpen(true);
    if (isMounted.current) {
      setLoading(false);
    }
    handleSelectTicket(ticket);
    history.push(`/tickets/${ticket.uuid}`);
  };

  const handleOpenAssignAttendantModal = () => {
    setTransferMode("assign");
    setLoading(true);
    setTransferTicketModalOpen(true);
    if (isMounted.current) {
      setLoading(false);
    }
    handleSelectTicket(ticket);
    history.push(`/tickets/${ticket.uuid}`);
  };

  const handleOpenNewTicketModal = () => {
    setNewTicketModalOpen(true);
  };

  const handleCloseNewTicketModal = (newTicket) => {
    setNewTicketModalOpen(false);
    if (newTicket) {
      // Se um novo ticket foi criado, redirecionar para ele
      handleSelectTicket(newTicket);
      history.push(`/tickets/${newTicket.uuid}`);
    }
  };

  const handleAcepptTicket = async (id) => {
    setLoading(true);
    try {
      const otherTicket = await api.put(`/tickets/${id}`, {
        status:
          ticket.isGroup && ticket.channel === "whatsapp" ? "group" : "open",
        userId: user?.id,
      });

      if (otherTicket.data.id !== ticket.id) {
        if (otherTicket.data.userId !== user?.id) {
          setOpenAlert(true);
          setUserTicketOpen(otherTicket.data.user.name);
          setQueueTicketOpen(otherTicket.data.queue.name);
        } else {
          setLoading(false);
          setTabOpen(ticket.isGroup ? "group" : "open");
          handleSelectTicket(otherTicket.data);
          history.push(`/tickets/${otherTicket.uuid}`);
        }
      } else {
        let setting;

        try {
          setting = await getSetting({
            column: "sendGreetingAccepted",
          });
        } catch (err) {
          toastError(err);
        }

        if (
          setting.sendGreetingAccepted === "enabled" &&
          (!ticket.isGroup || ticket.whatsapp?.groupAsTicket === "enabled")
        ) {
          handleSendMessage(ticket.id);
        }
        if (isMounted.current) {
          setLoading(false);
        }

        setTabOpen(ticket.isGroup ? "group" : "open");
        handleSelectTicket(ticket);
        history.push(`/tickets/${ticket.uuid}`);
      }
    } catch (err) {
      setLoading(false);
      toastError(err);
    }
  };

  const handleSendMessage = async (id) => {
    let setting;

    try {
      setting = await getSetting({
        column: "greetingAcceptedMessage",
      });
    } catch (err) {
      toastError(err);
    }
    if (!setting.greetingAcceptedMessage) {
      toast.warning(
        i18n.t("messagesList.header.buttons.greetingAcceptedMessage")
      );
      return;
    }
    const msg = `${setting.greetingAcceptedMessage}`;
    const message = {
      read: 1,
      fromMe: true,
      mediaUrl: "",
      body: `${msg.trim()}`,
    };
    try {
      await api.post(`/messages/${id}`, message);
    } catch (err) {
      toastError(err);
    }
  };

  const handleCloseAlert = useCallback(() => {
    setOpenAlert(false);
    setLoading(false);
  }, []);

  const handleSelectTicket = (ticket) => {
    const code = uuidv4();
    const { id, uuid, status } = ticket;
    setCurrentTicket({ id, uuid, status, code });
  };

  const handleUpdateTicketStatusWithData = async (
    ticketData,
    sendFarewellMessage,
    finalizacaoMessage
  ) => {
    try {
      await api.put(`/tickets/${ticket.id}`, {
        ...ticketData,
        sendFarewellMessage,
        finalizacaoMessage,
      });
      toast.success("Ticket finalizado com sucesso!");
      history.push(`/tickets/`);
    } catch (err) {
      toastError(err);
    }
  };

  // Função para espionar ticket chatbot
  const handleSpyTicket = () => {
    handleSelectTicket(ticket);
    history.push(`/tickets/${ticket.uuid}`);
  };

  // Lógica de permissão para mensagens pending - MOVIDA PARA DEPOIS DE TODAS AS FUNÇÕES
  const shouldBlurMessages = ticket.status === "pending" && user?.allowSeeMessagesInPendingTickets === "disabled";

  // Função para renderizar a mensagem com base na permissão - MOVIDA PARA DEPOIS DE TODAS AS FUNÇÕES
  const renderLastMessage = () => {
    if (shouldBlurMessages) {
      return (
        <MarkdownWrapper>
          {i18n.t("tickets.messageHidden") || "Mensagem oculta"}
        </MarkdownWrapper>
      );
    }

    if (!ticket.lastMessage) {
      return <br />;
    }

    if (ticket.lastMessage.includes("data:image/png;base64")) {
      return <MarkdownWrapper>Localização</MarkdownWrapper>;
    }

    if (ticket.lastMessage.includes("BEGIN:VCARD")) {
      return <MarkdownWrapper>Contato</MarkdownWrapper>;
    }

    return (
      <MarkdownWrapper>
        {truncate(ticket.lastMessage, 40)}
      </MarkdownWrapper>
    );
  };

  return (
    <React.Fragment key={ticket.id}>
      {openAlert && (
        <ShowTicketOpen
          isOpen={openAlert}
          handleClose={handleCloseAlert}
          user={userTicketOpen}
          queue={queueTicketOpen}
        />
      )}
      {showTicketLogOpen && (
        <ShowTicketLogModal
          isOpen={showTicketLogOpen}
          handleClose={() => setShowTicketLogOpen(false)}
          ticketId={ticket.id}
        />
      )}
      {openTicketMessageDialog && (
        <TicketMessagesDialog
          open={openTicketMessageDialog}
          handleClose={() => setOpenTicketMessageDialog(false)}
          ticketId={ticket.id}
        />
      )}
      {acceptTicketWithouSelectQueueOpen && (
        <AcceptTicketWithouSelectQueue
          modalOpen={acceptTicketWithouSelectQueueOpen}
          onClose={(e) => setAcceptTicketWithouSelectQueueOpen(false)}
          ticketId={ticket.id}
          ticket={ticket}
        />
      )}
      {transferTicketModalOpen && (
        <TransferTicketModalCustom
          modalOpen={transferTicketModalOpen}
          onClose={handleCloseTransferTicketModal}
          ticketid={ticket.id}
          ticket={ticket}
          mode={transferMode}
        />
      )}
      {newTicketModalOpen && (
        <NewTicketModal
          modalOpen={newTicketModalOpen}
          onClose={handleCloseNewTicketModal}
          initialContact={ticket.contact}
        />
      )}
      <ListItem
        button
        dense
        disableGutters
        onContextMenuCapture={(e) => e.preventDefault()}
        onContextMenu={(e) => handleContextMenu(e, ticket)}
        onClick={(e) => {
          console.log("e", e);
          const isCheckboxClicked =
            (e.target.tagName.toLowerCase() === "input" &&
              e.target.type === "checkbox") ||
            (e.target.tagName.toLowerCase() === "svg" &&
              e.target.type === undefined) ||
            (e.target.tagName.toLowerCase() === "path" &&
              e.target.type === undefined);

          if (isCheckboxClicked) return;

          handleSelectTicket(ticket);
        }}
        selected={ticketId && ticketId === ticket.uuid}
        className={clsx(classes.ticket, {
          [classes.pendingTicket]: ticket.status === "pending",
        })}
      >
        <ListItemAvatar style={{ marginLeft: "2px" }}>
          <Avatar
            style={{
              width: "50px",
              height: "50px",
              borderRadius: "50%",
            }}
            src={`${ticket?.contact?.profilePicUrl || ticket?.contact?.urlPicture}`}
            className={classes.clickableAvatar}
            onClick={handleImageClick}
            onContextMenu={(e) => e.preventDefault()}
          />
        </ListItemAvatar>
        <ListItemText
          onContextMenu={(e) => e.preventDefault()}
          disableTypography
          primary={
            <span className={classes.primaryContentRow}>
              <Typography
                noWrap
                component="span"
                variant="body2"
                className={classes.primaryLeftContent}
              >
                {ticket.isGroup && ticket.channel === "whatsapp" && (
                  <GroupIcon
                    fontSize="small"
                    style={{
                      color: grey[700],
                      marginBottom: "-1px",
                      marginLeft: "5px",
                    }}
                  />
                )}{" "}
                &nbsp;
                {ticket.channel && (
                  <ConnectionIcon
                    width="20"
                    height="20"
                    className={classes.connectionIcon}
                    connectionType={ticket.channel}
                  />
                )}{" "}
                &nbsp;
                {truncate(ticket.contact?.name, 60)}
              </Typography>
              {ticket.lastMessage && (
                <Typography
                  className={
                    Number(ticket.unreadMessages) > 0
                      ? classes.lastMessageTimeUnread
                      : classes.lastMessageTime
                  }
                  component="span"
                  variant="body2"
                >
                  {moment.utc(ticket.updatedAt).tz(companyTimezone).format("YYYY-MM-DD") === moment().tz(companyTimezone).format("YYYY-MM-DD") ? (
                    <>{formatCompanyTime(ticket.updatedAt, companyTimezone)}</>
                  ) : (
                    <>{formatCompanyDate(ticket.updatedAt, companyTimezone)}</>
                  )}
                </Typography>
              )}
            </span>
          }
          secondary={
            <span className={classes.secondaryContentRow}>
              <Typography
                className={
                  Number(ticket.unreadMessages) > 0
                    ? `${classes.contactLastMessageUnread} ${classes.secondaryLeftContent}`
                    : `${classes.contactLastMessage} ${classes.secondaryLeftContent}`
                }
                noWrap
                component="span"
                variant="body2"
              >
                {renderLastMessage()}
                <span className={classes.secondaryContentSecond}>
                  {ticket?.whatsapp ? (
                    <Badge
                      className={classes.connectionTag}
                      style={{
                        backgroundColor:
                          ticket.channel === "whatsapp"
                            ? ticket.whatsapp?.color || "#25D366"
                            : ticket.channel === "facebook"
                            ? "#4267B2"
                            : "#E1306C",
                      }}
                    >
                      {ticket.whatsapp?.name.toUpperCase()}
                    </Badge>
                  ) : (
                    <br></br>
                  )}
                  {
                    <Badge
                      style={{
                        backgroundColor: ticket.queue?.color || "#7c7c7c",
                      }}
                      className={classes.connectionTag}
                    >
                      {ticket.queueId
                        ? ticket.queue?.name.toUpperCase()
                        : ticket.status === "lgpd"
                        ? "LGPD"
                        : `${i18n.t("momentsUser.noqueue")}`}
                    </Badge>
                  }
                  {ticket?.user && (
                    <Badge
                      style={{ backgroundColor: "#000000" }}
                      className={classes.connectionTag}
                    >
                      {ticket.user?.name.toUpperCase()}
                    </Badge>
                  )}
                </span>
                <span className={classes.secondaryContentSecond}>
                  {ticket?.contact?.tags?.map((tag) => {
                    return (
                      <ContactTag
                        tag={tag}
                        key={`ticket-contact-tag-${ticket.id}-${tag.id}`}
                      />
                    );
                  })}
                </span>
                <span className={classes.secondaryContentSecond}>
                  {ticket.tags?.map((tag) => {
                    return (
                      <ContactTag
                        tag={tag}
                        key={`ticket-contact-tag-${ticket.id}-${tag.id}`}
                      />
                    );
                  })}
                </span>
              </Typography>

              <span className={classes.ticketRightInfo}>
                {(shouldBlurMessages || Number(ticket.unreadMessages) > 0) && (
                  <span className={classes.newMessagesCount}>
                    {shouldBlurMessages ? "?" : ticket.unreadMessages}
                  </span>
                )}
              </span>
            </span>
          }
        />
      </ListItem>
      {isContextMenuOpen &&
        selectedTicketForMenu?.id === ticket.id &&
        contextMenuPosition && (
          <Paper
            key={contextMenuInstanceKey}
            ref={menuPaperRef}
            className={classes.contextMenuPaper}
            style={{
              position: "fixed",
              top: contextMenuPosition.mouseY,
              left: contextMenuPosition.mouseX,
              zIndex: 1300,
            }}
          >
        {ticket.status === "chatbot" && (
          <MenuItem
            className={classes.contextMenuItem}
            onClick={handleMenuAction(() => handleSpyTicket())}
          >
            <ListItemIcon className={classes.contextMenuIcon}>
              <VisibilityIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText primary="Espiar conversa do chatbot" />
          </MenuItem>
        )}
        {ticket.status === "pending" &&
          (ticket.queueId === null || ticket.queueId === undefined) && (
            <MenuItem
              className={classes.contextMenuItem}
              onClick={handleMenuAction(() =>
                handleOpenAcceptTicketWithouSelectQueue()
              )}
            >
              <ListItemIcon className={classes.contextMenuIcon}>
                <Done fontSize="small" />
              </ListItemIcon>
              <ListItemText primary={i18n.t("ticketsList.buttons.accept")} />
            </MenuItem>
          )}
        {!ticket.userId && (
          <MenuItem
            className={classes.contextMenuItem}
            onClick={handleMenuAction(() => handleOpenAssignAttendantModal())}
          >
            <ListItemIcon className={classes.contextMenuIcon}>
              <PersonAdd fontSize="small" />
            </ListItemIcon>
            <ListItemText primary="Definir Atendente" />
          </MenuItem>
        )}
        {ticket.status === "pending" && ticket.queueId !== null && (
          <MenuItem
            className={classes.contextMenuItem}
            onClick={handleMenuAction(() => handleAcepptTicket(ticket.id))}
          >
            <ListItemIcon className={classes.contextMenuIcon}>
              <Done fontSize="small" />
            </ListItemIcon>
            <ListItemText primary={i18n.t("ticketsList.buttons.accept")} />
          </MenuItem>
        )}
        {(ticket.status === "pending" ||
          ticket.status === "open" ||
          ticket.status === "group") &&
          ticket.userId && (
          <MenuItem
            className={`${classes.contextMenuItem} ${classes.contextMenuTransfer}`}
            onClick={handleMenuAction(() => handleOpenTransferModal())}
          >
            <ListItemIcon className={classes.contextMenuIcon}>
              <SwapHoriz fontSize="small" />
            </ListItemIcon>
            <ListItemText primary={i18n.t("ticketsList.buttons.transfer")} />
          </MenuItem>
        )}

        {(ticket.status === "open" || ticket.status === "group") && (
          <MenuItem
            className={classes.contextMenuItem}
            disabled={!canClosePendingTicket}
            onClick={handleMenuAction(() => canClosePendingTicket && handleReturnToQueue(ticket.id))}
          >
            <ListItemIcon className={classes.contextMenuIcon}>
              <Undo fontSize="small" />
            </ListItemIcon>
            <ListItemText primary={i18n.t("tickets.buttons.returnQueue")} />
          </MenuItem>
        )}

        {((ticket.status === "open" || ticket.status === "group") ||
          ((ticket.status === "pending" || ticket.status === "lgpd") &&
            canClosePendingTicket)) && (
          <Divider className={classes.contextMenuDivider} />
        )}

        {(ticket.status === "open" || ticket.status === "group") && (
          <MenuItem
            className={`${classes.contextMenuItem} ${classes.contextMenuDanger}`}
              disabled={!canClosePendingTicket}
              onClick={handleMenuAction(() => canClosePendingTicket && handleCloseTicket(ticket.id))}
            >
              <ListItemIcon className={classes.contextMenuIcon}>
                <CheckCircleOutline fontSize="small" />
              </ListItemIcon>
              <ListItemText primary={i18n.t("messagesList.header.buttons.resolve")} />
            </MenuItem>
        )}
        {(ticket.status === "pending" || ticket.status === "lgpd") && (
            <MenuItem
              className={`${classes.contextMenuItem} ${classes.contextMenuDanger}`}
              disabled={!canClosePendingTicket}
              onClick={handleMenuAction(() => canClosePendingTicket && handleCloseIgnoreTicket(ticket.id))}
            >
              <ListItemIcon className={classes.contextMenuIcon}>
                <CheckCircleOutline fontSize="small" />
              </ListItemIcon>
              <ListItemText primary={i18n.t("ticketsList.buttons.closed") || "Fechar ticket"} />
            </MenuItem>
          )}
        <MenuItem
          className={classes.contextMenuItem}
          disabled={!canDeleteTicket}
          onClick={handleMenuAction(() => canDeleteTicket && setConfirmationOpen(true))}
        >
          <ListItemIcon className={classes.contextMenuIcon}>
            <DeleteOutline fontSize="small" />
          </ListItemIcon>
          <ListItemText primary={i18n.t("tickets.buttons.deleteTicket")} />
        </MenuItem>
        <MenuItem
          className={classes.contextMenuItem}
          disabled={!canUseConnectionActions}
          onClick={handleMenuAction(() => canUseConnectionActions && handleEnableIntegration())}
        >
          <ListItemIcon className={classes.contextMenuIcon}>
            <DeviceHubOutlined fontSize="small" />
          </ListItemIcon>
          <ListItemText
            primary={
              enableIntegration === true
                ? i18n.t("messagesList.header.buttons.disableIntegration")
                : i18n.t("messagesList.header.buttons.enableIntegration")
            }
          />
        </MenuItem>
        <MenuItem
          className={classes.contextMenuItem}
          disabled={!canViewTicketHistory}
          onClick={handleMenuAction(() => canViewTicketHistory && handleShowLogTicket())}
        >
          <ListItemIcon className={classes.contextMenuIcon}>
            <History fontSize="small" />
          </ListItemIcon>
          <ListItemText primary={i18n.t("messagesList.header.buttons.logTicket")} />
        </MenuItem>
        <MenuItem
          className={classes.contextMenuItem}
          disabled={!canViewTicketHistory}
          onClick={handleMenuAction(() => canViewTicketHistory && handleExportPDF())}
        >
          <ListItemIcon className={classes.contextMenuIcon}>
            <PictureAsPdf fontSize="small" />
          </ListItemIcon>
          <ListItemText primary={i18n.t("ticketsList.buttons.exportAsPDF")} />
        </MenuItem>
        {ticket.status === "closed" && (
          <MenuItem
            className={classes.contextMenuItem}
            onClick={handleMenuAction(() => handleOpenNewTicketModal())}
          >
            <ListItemIcon className={classes.contextMenuIcon}>
              <Add fontSize="small" />
            </ListItemIcon>
            <ListItemText primary="Criar Novo Ticket" />
          </MenuItem>
        )}
          </Paper>
        )}
      <ConfirmationModal
        title={`${i18n.t("ticketOptionsMenu.confirmationModal.title")} #${getTicketDisplayNumber(ticket)}?`}
        open={confirmationOpen}
        onClose={setConfirmationOpen}
        onConfirm={handleDeleteTicket}
      >
        {i18n.t("ticketOptionsMenu.confirmationModal.message")}
      </ConfirmationModal>

      {/* Modal de Finalização de Venda */}
      {openFinalizacaoVenda && (
        <FinalizacaoVendaModal
          open={openFinalizacaoVenda}
          onClose={() => setOpenFinalizacaoVenda(false)}
          ticket={ticket}
          onFinalizar={(ticketData) => {
            setOpenFinalizacaoVenda(false);
            setTicketDataToFinalize(ticketData);
            setShowFinalizacaoOptions(true);
          }}
        />
      )}

      {/* Modal de Opções de Finalização */}
      {showFinalizacaoOptions && (
        <Dialog
          open={showFinalizacaoOptions}
          onClose={() => setShowFinalizacaoOptions(false)}
          aria-labelledby="finalizacao-options-title"
        >
          <DialogTitle id="finalizacao-options-title">
            Como deseja finalizar?
          </DialogTitle>
          <DialogActions>
            <Button
              onClick={async () => {
                setShowFinalizacaoOptions(false);
                await handleUpdateTicketStatusWithData(
                  ticketDataToFinalize,
                  false,
                  null
                );
              }}
              style={{ background: theme.palette.primary.main, color: "white" }}
            >
              {i18n.t("messagesList.header.dialogRatingWithoutFarewellMsg")}
            </Button>
            <Button
              onClick={async () => {
                setShowFinalizacaoOptions(false);
                await handleUpdateTicketStatusWithData(
                  ticketDataToFinalize,
                  true,
                  null
                );
              }}
              style={{ background: theme.palette.primary.main, color: "white" }}
            >
              {i18n.t("messagesList.header.dialogRatingCancel")}
            </Button>
          </DialogActions>
        </Dialog>
      )}

      {/* Modal da Imagem */}
      <Dialog
        open={imageModalOpen}
        onClose={handleImageModalClose}
        className={classes.imageModal}
        maxWidth="md"
        fullWidth
      >
        <DialogContent className={classes.imageModalContent}>
          <img 
            src={ticket?.contact?.profilePicUrl || ticket?.contact?.urlPicture} 
            alt={ticket?.contact?.name || "Foto do contato"}
            className={classes.expandedImage}
          />
        </DialogContent>
      </Dialog>
    </React.Fragment>
  );
};

export default TicketListItemCustom;
